export const wsItemError = (downloads, item) => {
    const { correlationId, message, filename, error } = item;
    const newDownloads = Array.from(downloads);
    const itemToUpdate = newDownloads.find(({ id }) => id === correlationId);
    if (!itemToUpdate) {
        newDownloads.push({
            id: correlationId,
            url: "",
            name: filename,
            error: true,
            loading: false,
            tooltip: error || message || "",
        });
    }
    else {
        const itemIndex = newDownloads.indexOf(itemToUpdate);
        newDownloads[itemIndex] = {
            ...itemToUpdate,
            name: filename,
            error: true,
            loading: false,
            tooltip: error || message || "",
        };
    }
    return newDownloads;
};
export const wsItemUpdate = (downloads, item) => {
    const { correlationId, message, filename } = item;
    const newDownloads = Array.from(downloads);
    const itemToUpdate = newDownloads.find(({ id }) => id === correlationId);
    if (!itemToUpdate) {
        newDownloads.push({
            id: correlationId,
            loading: true,
            name: filename,
            url: message,
        });
    }
    else {
        const itemIndex = newDownloads.indexOf(itemToUpdate);
        newDownloads[itemIndex] = {
            ...itemToUpdate,
            url: message,
            name: filename,
        };
    }
    return newDownloads;
};
export const wsItemFinish = (downloads, item) => {
    const { correlationId, filename, message } = item;
    const newDownloads = Array.from(downloads);
    const itemToUpdate = newDownloads.find(({ id }) => id === correlationId);
    if (!itemToUpdate) {
        newDownloads.push({
            id: correlationId,
            loading: false,
            name: filename,
            url: message,
        });
    }
    else {
        const itemIndex = newDownloads.indexOf(itemToUpdate);
        newDownloads[itemIndex] = {
            ...itemToUpdate,
            url: message,
            loading: false,
        };
    }
    return newDownloads;
};
